import {createTrivialContext} from "../ui/TrivialProvider";

interface AuthContextProps {
    reloadAuth: () => void
    logout: () => void
}
export const [useAuthCtx, AuthCtxProvider] = createTrivialContext<AuthContextProps>('Auth')
